
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getClubActivities",
      resolverType: "query",
      routePath: "/getClubActivities",
      httpMethod: "POST",
    });
  